import { render, staticRenderFns } from "./ExpiredLinkPage.vue?vue&type=template&id=6a71f4b9&scoped=true&"
import script from "./ExpiredLinkPage.vue?vue&type=script&lang=js&"
export * from "./ExpiredLinkPage.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredLinkPage.vue?vue&type=style&index=0&id=6a71f4b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a71f4b9",
  null
  
)

export default component.exports